import TableNotAvailable from './TableNotAvailable';

export default TableNotAvailable;
